export default {
  SET_COLORS(state, data) {
    state.colorOptions = data;
  },
  SET_PORT_OPTIONS(state, data) {
    state.portOptions = data;
  },
  SET_DISPLAY_SETTINGS(state, data) {
    state.displaySettings = data;
  },
  SET_SELECTED_PORT(state, data) {
    state.selectedPort = data;
  },
  SET_STORED_MASTER_SEARCH_CONDITION(state, data) {
    state.storedMasterSearchCondition = data;
  },
  SET_VESSELS_DATA(state, payload) {
    const indexNumber = state.vesselsData.findIndex(
      (el) => String(el.id) === String(payload.id),
    );
    // 削除の場合
    if (payload.changeType === "removed") {
      state.vesselsData.splice(indexNumber, 1);
      return;
    }

    // 変更の場合
    if (indexNumber !== -1) {
      state.vesselsData.splice(indexNumber, 1, payload);
      return;
    }
    // 追加の場合
    state.vesselsData.push(payload);
  },
  ADD_VESSELS_SUBSCRIBE_LIST(state, payload) {
    state.vesselsSubscribeList.push(payload);
  },
  INIT_VESSELS_SUBSCRIBE_LIST(state) {
    state.vesselsSubscribeList = [];
  },
  RESET_VESSELS_DATA(state) {
    state.vesselsData = [];
  },
  SET_GKMG_PORT_MASTER_AUTH(state, data) {
    state.gkmgPortMasterAuth = data;
  },
};
